import { render, staticRenderFns } from "./ResponsiveGrid.vue?vue&type=template&id=0928b99e&"
import script from "./ResponsiveGrid.vue?vue&type=script&lang=js&"
export * from "./ResponsiveGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports